// extracted by mini-css-extract-plugin
export var readonly = "_go-1";
export var star = "_go-0";